import { render, staticRenderFns } from "./DataProperty.vue?vue&type=template&id=76238ca9&scoped=true"
import script from "./DataProperty.vue?vue&type=script&lang=js"
export * from "./DataProperty.vue?vue&type=script&lang=js"
import style0 from "./DataProperty.vue?vue&type=style&index=0&id=76238ca9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76238ca9",
  null
  
)

export default component.exports